export default "__VITE_ASSET__DfI38eiY__"